import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import Header from "../../components/header";
import ModalElement from "./modal";
import Row from "./row";
import Empty from "../../components/empty";
import api from "../../api";

const TechControl = ({
                         setPage, statusColored,
                         subDataStatus, data, setData, headerData, status, confirm
                     }) => {
    const [openModal, setOpenModal] = useState(false)
    const [showVideo, setShowVideo] = useState(false);

    const handlerClick = async (id, value) => {
        console.log("Local storage token: " + localStorage.getItem("token"));
        console.log("Use local storage token: " + localStorage.getItem("token"));
        setData(data.map((el) => el.score_tech_control_id === id ? ({...el, type: value}) : el))
        await api().post(`/coach/techcontrol/send/${id}/${value}/${localStorage.getItem("token")}`).then(async (res) => {
        })
    }

    useEffect(() => {
        if (status !== 'wait') {
            setOpenModal(false)
        }
    }, [status])

    return (
        <div className={s.techcontrol}>
            <Header disabled={data?.length === 0 || !data} headerData={headerData}
                    openModal={() => setOpenModal(true)} showVideo={showVideo} setShowVideo={setShowVideo}/>

            {(data?.length === 0 || !data) ? <Empty/> : <div className={s.content}>
                {data?.map((el, i) => <Row
                    isFirstElement={i === 0}
                    statusColored={statusColored}
                    row1_name={i === 0 && subDataStatus && subDataStatus?.techcontrol_other?.length > 0 && subDataStatus?.techcontrol_other[0]?.techcontrol_name}
                    row2_name={i === 0 && subDataStatus && subDataStatus?.techcontrol_other?.length > 0 && subDataStatus?.techcontrol_other[1]?.techcontrol_name}
                    row1={subDataStatus && subDataStatus?.techcontrol_other?.length > 0 && subDataStatus?.techcontrol_other[0]?.elements[i]}
                    row2={subDataStatus && subDataStatus?.techcontrol_other?.length > 0 && subDataStatus?.techcontrol_other[1]?.elements[i]}
                    subDataStatus={statusColored ? subDataStatus : null}
                    type={Number(el.value)}
                    key={el.score_tech_control_id}
                    handlerClick={handlerClick}
                    id={el.score_tech_control_id} {...el}/>)}

            </div>}
            {openModal &&
                <ModalElement
                    subDataStatus={statusColored ? subDataStatus : null}
                    statusColored={statusColored}
                    confirm={confirm} setPage={setPage} open={openModal} onClose={() => setOpenModal(false)}
                    data={data} status={status}/>}
        </div>
    );
};

export default TechControl;
